(() => {
  function moveSelectorIntoProductForm() {
    const parking = document.getElementById('avd-driver-selector-parking');
    const parkedSelector = parking
      ? parking.querySelector('[data-avd-driver-selector]')
      : null;

    if (!parking || !parkedSelector) return;

    const hulkOptions = document.querySelector('[id^="hulkapps_custom_options_"]');
    const addButton = document.querySelector('button[name="add"], [id^="AddToCart-"]');

    const target = hulkOptions || addButton;

    if (!target || !target.parentNode) return;

    target.parentNode.insertBefore(parkedSelector, target);
    parking.remove();
  }

  moveSelectorIntoProductForm();

  const selectorRoot = document.querySelector('[data-avd-driver-selector]');
  if (!selectorRoot) return;

  const productForm =
    selectorRoot.closest('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  if (!productForm) return;

  const routeRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const addUrl = `${routeRoot}cart/add.js`;
  const cartUrl = `${routeRoot}cart`;
  const productCache = {};

  function parseJsonAttribute(el, attrName) {
    if (!el) return [];

    try {
      return JSON.parse(el.getAttribute(attrName) || '[]');
    } catch (error) {
      return [];
    }
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(cents / 100);
  }

  function isIncludedDriverOption(option) {
    if (!option) return false;

    return (
      option.value === 'included' ||
      option.value === 'included-g10-vintage'
    );
  }

  function getDriverSelects() {
    return Array.from(selectorRoot.querySelectorAll('[data-avd-driver-select]'));
  }

  function getSelectedDriverOptions() {
    return getDriverSelects()
      .filter((select) => select.offsetParent !== null)
      .map((select) => select.options[select.selectedIndex])
      .filter(Boolean);
  }

  function getCabVariantId() {
    const idInput = productForm.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getQuantity() {
    const quantityInput = productForm.querySelector('[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getSelectedCabOptions() {
    const formData = new FormData(productForm);
    const options = {};

    for (const [key, value] of formData.entries()) {
      if (
        key.startsWith('options[') ||
        key === 'option1' ||
        key === 'option2' ||
        key === 'option3'
      ) {
        options[key] = value;
      }
    }

    return options;
  }

  function buildPairId() {
    return `avd-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  }

  function getCurrentCabVariant() {
    const cabVariantId = getCabVariantId();
    const cabVariants = parseJsonAttribute(selectorRoot, 'data-cab-variants');

    return cabVariants.find((variant) => String(variant.id) === String(cabVariantId)) || null;
  }

  function getCabVariantText() {
    const cabVariant = getCurrentCabVariant();

    if (!cabVariant) return '';

    return [
      cabVariant.title,
      cabVariant.option1,
      cabVariant.option2,
      cabVariant.option3
    ].filter(Boolean).join(' ').toLowerCase();
  }

function getAllSelectedProductText() {
  let text = getCabVariantText();

  document.querySelectorAll('select').forEach((select) => {
    // Ignore our custom speaker dropdowns
    if (select.closest('[data-avd-driver-selector]')) return;

    const selectedOption = select.options[select.selectedIndex];

    if (selectedOption) {
      text += ' ' + selectedOption.textContent;
      text += ' ' + selectedOption.value;
    }
  });

  document.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
    // Ignore our custom speaker controls if any exist
    if (input.closest('[data-avd-driver-selector]')) return;

    text += ' ' + input.value;

    const label = input.closest('label');
    if (label) {
      text += ' ' + label.textContent;
    }
  });

  return text.toLowerCase().replace(/\s+/g, ' ').trim();
}

  function getRequiredDriverSizes() {
 const text = getCabVariantText()
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

  const configText = text
    .replace(/uk/g, '')
    .replace(/usa/g, '')
    .replace(/canada/g, '')
    .replace(/europe/g, '')
    .replace(/australia/g, '')
    .replace(/new zealand/g, '')
    .replace(/japan/g, '')
    .replace(/rest of the world/g, '')
    .replace(/rest of world/g, '')
    .replace(/everywhere else/g, '')
    .trim();

  if (
    configText.includes('1215') ||
    configText.includes('12/15') ||
    configText.includes('12 15')
  ) {
    return ['12', '15'];
  }

  if (
    configText.includes('2x10') ||
    configText.includes('2 x 10') ||
    configText.includes('210') ||
    configText.includes('two 10')
  ) {
    return ['10', '10'];
  }

  if (
    configText.includes('2x12') ||
    configText.includes('2 x 12') ||
    configText.includes('212') ||
    configText.includes('two 8 ohm drivers') ||
    configText.includes('two 16 ohm drivers') ||
    configText.includes('two drivers')
  ) {
    return ['12', '12'];
  }

  if (
    configText.includes('2x15') ||
    configText.includes('2 x 15') ||
    configText.includes('215') ||
    configText.includes('two 15')
  ) {
    return ['15', '15'];
  }

  if (
    configText.includes('1x10') ||
    configText.includes('1 x 10') ||
    configText.includes('110')
  ) {
    return ['10'];
  }

  if (
    configText.includes('1x15') ||
    configText.includes('1 x 15') ||
    configText.includes('115')
  ) {
    return ['15'];
  }

  if (
    configText.includes('1x12') ||
    configText.includes('1 x 12') ||
    configText.includes('112sw') ||
    configText.includes('112 sw') ||
    configText.includes('112')
  ) {
    return ['12'];
  }

  return ['12'];
}

  function cabNeedsTwoDrivers() {
    return getRequiredDriverSizes().length > 1;
  }

function getCabRegion() {
  const cabVariant = getCurrentCabVariant();

  if (!cabVariant) return 'UK';

  const options = [
    cabVariant.option1,
    cabVariant.option2,
    cabVariant.option3
  ].filter(Boolean);

  const regionOption = options.find((option) => {
    const text = String(option).toLowerCase();

    return (
      text === 'uk' ||
      text.includes('europe') ||
      text.includes('usa') ||
      text.includes('canada') ||
      text.includes('australia') ||
      text.includes('new zealand') ||
      text.includes('japan') ||
      text.includes('everywhere') ||
      text.includes('rest of the world') ||
      text.includes('rest of world')
    );
  });

  if (!regionOption) return 'UK';

  const regionText = String(regionOption).toLowerCase();

  if (regionText === 'uk') return 'UK';

  return 'Everywhere else';
}

function cabNeedsFourOhm() {
  const text = getCabVariantText().toLowerCase();
  return text.includes('4ohm') || text.includes('4 ohm');
}

async function getDriverProduct(handle) {
  if (!handle) return null;

  if (Object.prototype.hasOwnProperty.call(productCache, handle)) {
    return productCache[handle];
  }

  const urls = [
    `${routeRoot}products/${handle}.js`,
    `/products/${handle}.js`
  ];

  for (const url of urls) {
    try {
      const response = await fetch(url, {
        headers: {
          Accept: 'application/json'
        }
      });

      if (response.ok) {
        const product = await response.json();
        productCache[handle] = product;
        return product;
      }

      console.warn('AVD driver product fetch failed:', handle, response.status, url);
    } catch (error) {
      console.warn('AVD driver product fetch error:', handle, url, error);
    }
  }

  // Do NOT permanently cache failures.
  // A temporary failed request should not make the speaker unavailable forever.
  return null;
}

  async function findMatchingDriverVariant(driverOption) {
    if (!driverOption) return null;
    if (isIncludedDriverOption(driverOption)) return null;

    const handle = driverOption.dataset.driverProductHandle;
    const product = await getDriverProduct(handle);

    if (!product || !product.variants || !product.variants.length) {
      return null;
    }

    const variants = product.variants;
    const cabRegion = getCabRegion().toLowerCase();
    const wantsUk = cabRegion.includes('uk');
    const wantsFourOhm = cabNeedsFourOhm();

    let candidates = variants.filter((variant) => {
      const title = String(variant.title || '').toLowerCase();

      if (wantsUk) {
        return title.includes('uk');
      }

      return (
        title.includes('everywhere') ||
        title.includes('europe') ||
        title.includes('usa') ||
        title.includes('canada') ||
        title.includes('rest of world') ||
        title.includes('rest of the world') ||
        title.includes('non uk') ||
        title.includes('non-uk')
      );
    });

    if (!candidates.length) {
      candidates = variants;
    }

    let match = null;

    if (wantsFourOhm) {
      match = candidates.find((variant) =>
        String(variant.title || '').toLowerCase().includes('4 ohm')
      );
    }

    if (!match) {
      match = candidates.find((variant) => {
        const title = String(variant.title || '').toLowerCase();

        return (
          title.includes('as chosen') ||
          !title.includes('4 ohm')
        );
      });
    }

    if (!match) {
      match = candidates[0];
    }

    return match;
  }

  function updateVisibleDriverFields() {
    const requiredSizes = getRequiredDriverSizes();

    getDriverSelects().forEach((select, index) => {
      const field = select.closest('[data-avd-driver-field]');
      const requiredSize = requiredSizes[index];

      if (!field) return;

      if (requiredSize) {
        field.style.display = '';
        select.dataset.requiredDriverSize = requiredSize;

        const label = field.querySelector('label');

        if (label) {
          if (requiredSizes.length > 1) {
            label.textContent = `Speaker / Driver ${index + 1} (${requiredSize}")`;
          } else {
            label.textContent = `Speaker / Driver (${requiredSize}")`;
          }
        }
      } else {
        field.style.display = 'none';
        select.dataset.requiredDriverSize = '';
        select.value = 'included';
      }
    });
  }

function filterDriverOptionsBySize() {
  const requiredSizes = getRequiredDriverSizes();

  getDriverSelects().forEach((select, index) => {
    const requiredSize = requiredSizes[index] || requiredSizes[0] || '12';
    const options = Array.from(select.options);

    options.forEach((option) => {
      const optionSize = option.dataset.driverSize || '12';
      const shouldShow = optionSize === requiredSize || optionSize === 'any';

      option.hidden = !shouldShow;
      option.disabled = !shouldShow;
    });

    const selectedOption = select.options[select.selectedIndex];
    const selectedStillAllowed =
      selectedOption &&
      !selectedOption.hidden &&
      !selectedOption.disabled;

    if (!selectedStillAllowed) {
      let preferredIncludedOption = null;

      if (requiredSize === '10') {
        preferredIncludedOption = options.find((option) => option.value === 'included-g10-vintage');
      } else if (requiredSize === '12') {
        preferredIncludedOption = options.find((option) => option.value === 'included');
      }

      const fallbackOption = options.find((option) => !option.hidden && !option.disabled);

      const optionToSelect =
        preferredIncludedOption &&
        !preferredIncludedOption.hidden &&
        !preferredIncludedOption.disabled
          ? preferredIncludedOption
          : fallbackOption;

      if (optionToSelect) {
        select.value = optionToSelect.value;
      }
    }
  });
}

  function findMainPriceEls() {
    const selectors = [
      '[data-product-price]',
      '[data-price]',
      '.product__price',
      '.product-price__price',
      '.product-single__price',
      '.product-single__prices',
      '.price-item--regular',
      '.price__regular .price-item',
      '.ecom-product-single__price',
      '.ecom-product-single__price-wrapper',
      '#ProductPrice',
      '#ProductPrice-product-template'
    ];

    const found = [];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (selectorRoot.contains(el)) return;
        if (found.includes(el)) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.width > 0 && rect.height > 0;

        if (isVisible) {
          found.push(el);
        }
      });
    });

    return found.slice(0, 3);
  }

  const mainPriceEls = findMainPriceEls();

  mainPriceEls.forEach((el) => {
    if (!el.dataset.avdOriginalPriceHtml) {
      el.dataset.avdOriginalPriceHtml = el.innerHTML;
    }
  });

  let updateToken = 0;

async function refreshDropdownOptionPrices(currentToken) {
  filterDriverOptionsBySize();

  const selects = getDriverSelects();

  await Promise.all(selects.map(async (select) => {
    const options = Array.from(select.options);

    await Promise.all(options.map(async (option) => {
      const cleanBaseLabel =
        option.dataset.driverBaseLabel ||
        option.dataset.driverLabel ||
        option.value;

      option.textContent = cleanBaseLabel;

      if (option.hidden || option.disabled) {
        option.dataset.driverPrice = '0';
        option.dataset.driverVariantId = '';
        return;
      }

      if (isIncludedDriverOption(option)) {
        option.textContent = `${cleanBaseLabel} — included`;
        option.dataset.driverPrice = '0';
        option.dataset.driverVariantId = '';
        return;
      }

      const variant = await findMatchingDriverVariant(option);

      // Important: if a newer update has started, do not let this older fetch overwrite anything.
      if (currentToken !== updateToken) return;

      if (!variant) {
        option.textContent = `${cleanBaseLabel}`;
        option.dataset.driverPrice = '0';
        option.dataset.driverVariantId = '';
        return;
      }

      const price = Number(variant.price || 0);
      option.textContent = `${cleanBaseLabel} — +${formatMoney(price)}`;
      option.dataset.driverPrice = String(price);
      option.dataset.driverVariantId = String(variant.id);
    }));
  }));
}

  async function updateDisplayedPrices() {
    const currentToken = ++updateToken;

    updateVisibleDriverFields();

await refreshDropdownOptionPrices(currentToken);

    if (currentToken !== updateToken) return;

    const cabVariant = getCurrentCabVariant();
    const cabPrice = cabVariant ? Number(cabVariant.price || 0) : 0;

    const selectedDriverOptions = getSelectedDriverOptions();

    const driverTotal = selectedDriverOptions.reduce((total, option) => {
      if (!option || isIncludedDriverOption(option)) return total;
      return total + Number(option.dataset.driverPrice || 0);
    }, 0);

    const hasCustomDriver = selectedDriverOptions.some((option) => {
      return option && !isIncludedDriverOption(option) && option.dataset.driverVariantId;
    });

    const totalPrice = cabPrice + driverTotal;

    mainPriceEls.forEach((el) => {
      if (!hasCustomDriver) {
        el.innerHTML = formatMoney(cabPrice);
      } else {
        const speakerWord = cabNeedsTwoDrivers() ? 'speakers' : 'speaker';
        el.innerHTML = `${formatMoney(totalPrice)} <small style="font-size:0.65em;font-weight:normal;">with selected ${speakerWord}</small>`;
      }
    });
  }

  selectorRoot.addEventListener('change', function () {
    updateDisplayedPrices();
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('[name="id"]') ||
      event.target.matches('select') ||
      event.target.matches('input[type="radio"]')
    ) {
      window.setTimeout(updateDisplayedPrices, 100);
      window.setTimeout(updateDisplayedPrices, 300);
    }
  });

  document.addEventListener('click', function () {
    window.setTimeout(updateDisplayedPrices, 150);
  });

  function setLoading(isLoading) {
    const submitButton = productForm.querySelector('[type="submit"], button[name="add"]');

    if (!submitButton) return;

    if (isLoading) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.dataset.originalText = submitButton.textContent;
      submitButton.textContent = 'Adding…';
      submitButton.disabled = true;
    } else {
      submitButton.removeAttribute('aria-busy');
      if (submitButton.dataset.originalText) {
        submitButton.textContent = submitButton.dataset.originalText;
      }
      submitButton.disabled = false;
    }
  }

  function showError(message) {
    let errorEl = selectorRoot.querySelector('[data-avd-driver-error]');

    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'avd-driver-selector__error';
      errorEl.setAttribute('data-avd-driver-error', '');
      selectorRoot.appendChild(errorEl);
    }

    errorEl.textContent = message;
  }

  function clearError() {
    const errorEl = selectorRoot.querySelector('[data-avd-driver-error]');
    if (errorEl) errorEl.textContent = '';
  }

  function groupDriverLineItems(selectedDriverOptions, quantity, driverPropertiesBase) {
    const grouped = {};

    selectedDriverOptions.forEach((option, index) => {
      if (!option || isIncludedDriverOption(option)) return;

      const variantId = option.dataset.driverVariantId;
      if (!variantId) return;

      const label = option.dataset.driverLabel || 'Custom driver';
      const position = index + 1;

      if (!grouped[variantId]) {
        grouped[variantId] = {
          id: Number(variantId),
          quantity: 0,
          properties: {
            ...driverPropertiesBase,
            'Speaker choice': label,
            'Driver position': `Driver ${position}`
          }
        };
      }

      grouped[variantId].quantity += quantity;
    });

    return Object.values(grouped);
  }

  productForm.addEventListener(
    'submit',
    async function (event) {
      await updateDisplayedPrices();

      const selectedDriverOptions = getSelectedDriverOptions();

      const hasCustomDriver = selectedDriverOptions.some((option) => {
        return option && !isIncludedDriverOption(option) && option.dataset.driverVariantId;
      });

      if (!hasCustomDriver) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      clearError();

      const cabVariantId = getCabVariantId();
      const quantity = getQuantity();

      if (!cabVariantId) {
        showError('Sorry, we could not identify the selected cab variant. Please refresh and try again.');
        return;
      }

      const cabTitle = selectorRoot.dataset.productTitle || document.title;
      const cabOptions = getSelectedCabOptions();
      const pairId = buildPairId();

      const selectedLabels = selectedDriverOptions.map((option, index) => {
        if (!option || isIncludedDriverOption(option)) {
          const label = option && option.dataset.driverBaseLabel
            ? option.dataset.driverBaseLabel
            : 'Included speaker';

          return `Driver ${index + 1}: ${label}`;
        }

        return `Driver ${index + 1}: ${option.dataset.driverLabel || 'Custom driver'}`;
      });

      const cabProperties = {
        'Speaker choice': selectedLabels.join(' / '),
        '_AVD pair ID': pairId
      };

      Object.entries(cabOptions).forEach(([key, value]) => {
        cabProperties[key] = value;
      });

      const driverPropertiesBase = {
        'For cab': cabTitle,
        '_AVD pair ID': pairId
      };

      Object.entries(cabOptions).forEach(([key, value]) => {
        driverPropertiesBase[key] = value;
      });

      const driverLineItems = groupDriverLineItems(
        selectedDriverOptions,
        quantity,
        driverPropertiesBase
      );

      const payload = {
        items: [
          {
            id: Number(cabVariantId),
            quantity,
            properties: cabProperties
          },
          ...driverLineItems
        ]
      };

      try {
        setLoading(true);

        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (!response.ok) {
          const message =
            data && data.description
              ? data.description
              : 'Sorry, something went wrong adding this cab and driver to your basket.';

          throw new Error(message);
        }

        window.location.href = cartUrl;
      } catch (error) {
        showError(error.message);
        setLoading(false);
      }
    },
    true
  );

  updateDisplayedPrices();
})();